import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";


function ListadoFacturas() {
  const { user } = useContext(AuthContext);
  const URL_FACTURAS = process.env.REACT_APP_URL_FACTURAS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_TIMBRAR = process.env.REACT_APP_URL_TIMBRAR;
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_SUCURSALES = process.env.REACT_APP_URL_SUCURSALES;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 90);
  
  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalAddenda, setModalAddenda] = useState(false);
  const toggleAddenda = () => setModalAddenda(!modalAddenda);

  const [sucursales, setSucursales] = useState([]);
  const [selectedSucursal, setSelectedSucursal] = useState("");
  const [surtidos, setSurtidos] = useState([]);

  const [addendaTipo, setAddendaTipo] = useState("");
  const [idFacturamaAddenda, setIdFacturamaAddenda] = useState("")
  const [fechaAddenda, setFechaAddenda] = useState("")
  const [serieAddenda, setSerieAddenda] = useState("")
  const [folioAddenda, setFolioAddenda] = useState("")
  const [pedidoAddenda, setPedidoAddenda] = useState("")
  const [fechaPedidoAddenda, setFechaPedidoAddenda] = useState("")
  const [rfcSucursalAddenda, setRfcSucursalAddenda] = useState("")
  const [aliasSucursalAddenda, setAliasSucursalAddenda] = useState("")
  const [direccionSucursalAddenda, setDireccionSucursalAddenda] = useState("")
  const [ciudadSucursalAddenda, setCiudadSucursalAddenda] = useState("")
  const [cpSucursalAddenda, setCpSucursalAddenda] = useState("")
  const [codigoSucursalAddenda, setCodigoSucursalAddenda] = useState("")
  const [cantidadCajasAddenda, setCantidadCajasAddenda] = useState("")
  const [subTotalAddenda, setSubTotalAddenda] = useState("")
  const [descuento1Addenda, setDescuento1Addenda] = useState("")
  const [descuento2Addenda, setDescuento2Addenda] = useState("")
  const [ivaAddenda, setIvaAddenda] = useState("")
  const [totalAddenda, setTotalAddenda] = useState("")
  const [cadenaOriginalAddenda, setCadenaOriginalAddenda] = useState("")


  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useEffect(() => {
    axios
    .get(`${URL_FACTURAS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allFacturas = response.data;
        // Array para pagination
        let arrayTabla = allFacturas
          .sort((a, b) => (a.idFactura < b.idFactura ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              is_active:a.is_active,
              fecha: a.fecha,
              idFactura: a.idFactura,
              folio: a.folio,
              serie: a.serie,
              clientes: a.clientes[0].nombre_comercial,
              idClientes: a.clientes[0]._id,
              vendedores: a.colaboradores[0].nombre + " " + a.colaboradores[0].apellido,
              total: a.total,
              idFacturama: a.idFacturama,
              timbre: a.timbre,
              subTotal: a.subTotal,
              iva: a.iva,
              descuentoNumero1: a.descuentoNumero1,
              descuentoNumero2: a.descuentoNumero2,
              cadenaSAT: a.cadenaSAT,
            }
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  let totalImportePDF = 0;
  let subTotalPDF = 0;
  let totalIVAPDF = 0;

  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        if(a.is_active == "Si"){
        totalImportePDF = totalImportePDF + a.total_general;
        subTotalPDF = subTotalPDF + a.subTotal;
        totalIVAPDF = totalIVAPDF + a.iva;
        return [
          a.numero,
          a.numeroFactura,
          a.fecha,
          a.clientes,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.subTotal),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.iva),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total_general),
          a.user,
        ]
      }else {
        return [
          a.numero,
          a.numeroFactura,
          a.fecha,
          a.clientes,
          "",
          "Cancelada",
          "",
          a.user,
        ]
      }
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF();
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 10, 33, 10);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 160, 23, 25, 25);
    doc.text(`Listado de Notas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["No.", "Factura", "Fecha", "Cliente", "SubTotal", "IVA", "Total", "Surtio"]],
      body: dataPDFLimpia,
      startY: 50,
      foot: [
        [
          "",
          "",
          "",
          "Totales",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(subTotalPDF),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalIVAPDF),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalImportePDF),

        ]
      ]
    });
    doc.save(`Facturas.pdf`);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        if(a.is_active == "Si"){
        return {
          Numero: a.numero,
          Factura: a.numeroFactura,
          Fecha: a.fecha,
          Cliente: a.clientes,
          SubTotal: a.subTotal,
          IVA: a.iva,
          Total: a.total_general,
          Surtio: a.user,
        }
        }else{
          return {
            Numero: a.numero,
            Factura: a.numeroFactura,
            Fecha: a.fecha,
            Cliente: a.clientes,
            SubTotal: 0,
            IVA: 0,
            Total: 0,
            Surtio: a.user,
          }
        }
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoFacturas";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoFacturas",
        sheetFilter: ["Numero", "Factura", "Fecha", "Cliente", "SubTotal", "IVA", "Total", "Surtio"],
        sheetHeader: ["Numero", "Factura", "Fecha", "Cliente", "SubTotal", "IVA", "Total", "Surtio"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        return [a.numero, a.numeroFactura, a.fecha, a.clientes, a.pedidos, a.subTotal, a.iva, a.total_general, a.user];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF();
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 10, 33, 10);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 160, 23, 25, 25);
    doc.text(`Listado de Notas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Numero", "Factura", "Fecha", "Cliente", "Pedido", "SubTotal", "IVA", "Total", "Surtio"]],
      body: dataPDFLimpia,
      startY: 50,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado de Facturas",
          email: mailTo,
          fileName: "ListadoFacturas.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Facturas.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }


  async function PDFOC(
    idFacturama,
    serie,
    folio
  ) {
    await axios
      .get(`${URL_TIMBRAR}ObtenerPDF/${idFacturama}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let facturaBase64 = response.data.respuesta.Content;
        
        const binaryData = atob(facturaBase64);
        
        const uint8Array = new Uint8Array(binaryData.length);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }
        
        const blob = new Blob([uint8Array], { type: "application/pdf" });
        
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Factura${serie}-${folio}.pdf`;
        
        a.click();
        
        URL.revokeObjectURL(url);
        
        
      })
      .catch((err) => {
        console.log(err);
      });
  }
  
  async function PDFOCXML(
    idFacturama,
    serie,
    folio
  ) {
    await axios
      .get(`${URL_TIMBRAR}ObtenerXML/${idFacturama}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
      const facturaXMLBase64 = response.data.respuesta.Content;

      const facturaBlob = b64toBlob(facturaXMLBase64, 'application/xml');

      const dataURL = URL.createObjectURL(facturaBlob);

      const a = document.createElement('a');
      a.href = dataURL;
      a.download = `Factura${serie}-${folio}.xml`;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      function b64toBlob(base64, mimeType) {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: mimeType });
      }

        
      })
      .catch((err) => {
        console.log(err);
      });
  }
  
  async function PDFOCXMLCANCELADA(
    id,
    serie,
    folio
  ) {
    await axios
      .get(`${URL_FACTURAS}/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let facturaXMLBase64 = response.data.respuestaFacturamaCancel[0].AcuseXmlBase64
        
      const facturaBlob = b64toBlob(facturaXMLBase64, 'application/xml');

      const dataURL = URL.createObjectURL(facturaBlob);

      const a = document.createElement('a');
      a.href = dataURL;
      a.download = `Factura${serie}-${folio}.xml`;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      function b64toBlob(base64, mimeType) {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: mimeType });
      }

        
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const headers = [
    { name: "Numero", field: "idFactura", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Vendedor", field: "vendedores", sortable: true },
    { name: "Folio", field: "folio", sortable: true },
    { name: "Total", field: "total", sortable: true },
    { name: "Timbre", field: "timbre", sortable: true },
    { name: "Detalles", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.vendedores.toLowerCase().includes(search.toLowerCase()) ||
          comment.timbre.toLowerCase().includes(search.toLowerCase()) ||
          comment.folio.toString().includes(search) ||
          comment.total.toString().includes(search)
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "folio"  &&
      sorting.field != "total"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "folio" &&
      sorting.field == "total")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "folio"  &&
      sorting.field == "total")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedFechaInicio,
    selectedFechaFin,
  ]);

  function cancelarFactura(id, idFacturama) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se cancelara la Factura!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cancelar!",
    }).then((result) => {
      if (result.isConfirmed) {
    axios
      .delete(`${URL_TIMBRAR}CancelFactura/${id}/${idFacturama}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(() => {
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    }
  });
  }

  function jalaAddenda(id, idClientes) {
    axios
      .get(`${URL_SUCURSALES}/clientes/${idClientes}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allSucursales = response.data;
        setSucursales(allSucursales);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_SURTIDOS}Factura/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allSurtidos = response.data;

        if (idClientes == "64625ba428aa2d00146fa99e") {
          let idsSur = allSurtidos.map((a) => a._id);          

          axios
            .post(`${URL_ARTICULOS_SURTIDOS}VariosSurtidos`,{
              variosSurtidos: idsSur
            },
             {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((response) => {
              let allSurtidos = response.data;

              setSurtidos(allSurtidos);
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          setSurtidos(allSurtidos);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    toggleAddenda();
  }


  function jalaSucursal(e){
    setSelectedSucursal(e)

    sucursales.map((a)=>{
      if(a._id == e){
        setDireccionSucursalAddenda(a.calle + " " + a.numero_ext + " " + a.numero_int + " "  + a.estado)
        setRfcSucursalAddenda(a.RFC)
        setAliasSucursalAddenda(a.alias)
        setCiudadSucursalAddenda(a.ciudad)
        setCpSucursalAddenda(a.cp)
        setCodigoSucursalAddenda(a.alias) //Hay q agregar codigo
      }
    })
  }

  async function generarAddenda() {
    try {
      const response = await axios
      .get(`${URL_TIMBRAR}ObtenerXML/${idFacturamaAddenda}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })

      const formattedDate = new Date(fechaAddenda).toISOString().slice(0, 10).replace(/-/g, '');
      const formattedDatePedido = new Date(fechaPedidoAddenda).toISOString().slice(0, 10).replace(/-/g, '');

      let artAdd = surtidos.map((a, index) => {
        const itemNumber = index + 1;
        const paddedCodigoCliente = a.articulos[0].codigoCliente.padStart(13, '0')
        return ` <lineItem type="SimpleInvoiceLineItemType" number=${itemNumber}>
        <tradeItemIdentification>
          <gtin>${paddedCodigoCliente}</gtin>
        </tradeItemIdentification>
        <alternateTradeItemIdentification type="BUYER_ASSIGNED">${paddedCodigoCliente}</alternateTradeItemIdentification>
        <codigoTallaInternoCop>
          <codigo>${a.articulos[0].codigoCliente}</codigo>
          <talla>${a.tallas[0].name}</talla>
        </codigoTallaInternoCop>
        <tradeItemDescriptionInformation language="ES">
          <longText>${a.articulos[0].descripcion}</longText>
        </tradeItemDescriptionInformation>
        <invoicedQuantity unitOfMeasure="PCE">${a.cantidad}</invoicedQuantity>
        <grossPrice>
          <Amount>${a.articulosPedidoCliente[0].precio}</Amount>
        </grossPrice>
        <netPrice>
                                                        <Amount>[PRODPRECIOBRUTO(#########.00)]</Amount>
        </netPrice>
        <palletInformation>
          <palletQuantity>${a.cantidad}</palletQuantity> 
          <description type="BOX" /> 
          <transport>
            <methodOfPayment>PREPAID_BY_SELLER</methodOfPayment>
          </transport>
                                                      <prepactCant>[PRODOBSERV]</prepactCant>
        </palletInformation>	
        <allowanceCharge allowanceChargeType="ALLOWANCE_GLOBAL">
          <specialServicesType>CAC</specialServicesType> 
          <monetaryAmountOrPercentage>
                                                        <percentagePerUnit>[PRODPORCENDESC1(#0.00)]</percentagePerUnit> 
            <ratePerUnit>
                                                        <amountPerUnit>[PRODPRECIO(#########.00)]</amountPerUnit>
            </ratePerUnit>
          </monetaryAmountOrPercentage>
        </allowanceCharge>
        <totalLineAmount>
          <grossAmount>
                                                          <Amount>[PRODSUBTOTMENOSDESC(#########.00)]</Amount>
          </grossAmount>
          <netAmount>
                                                            <Amount>[PRODSUBTOTAL(#########.00)]</Amount>
          </netAmount>
        </totalLineAmount>
      </lineItem>`
      })

      let artAddString = artAdd.join('');

      console.log("artAdd", artAddString)


      let textoAdenda = `<cfdi:Addenda>
      <requestForPayment type="SimpleInvoiceType" contentVersion="1.0" documentStructureVersion="CPLR1.0" documentStatus="ORIGINAL" DeliveryDate="${formattedDate}">
     <requestForPaymentIdentification>
       <entityType>INVOICE</entityType>
       <uniqueCreatorIdentification>${serieAddenda}${folioAddenda}</uniqueCreatorIdentification>
     </requestForPaymentIdentification>
     <orderIdentification>
       <referenceIdentification type="ON">${pedidoAddenda}</referenceIdentification>
       <ReferenceDate>${formattedDatePedido}</ReferenceDate>
     </orderIdentification>
     <seller>
       <gln>${rfcSucursalAddenda}</gln>
       <alternatePartyIdentification type="SELLER_ASSIGNED_IDENTIFIER_FOR_A_PARTY">73776</alternatePartyIdentification>
       <IndentificaTipoProv>2</IndentificaTipoProv>
     </seller>
     <shipTo>
     <gln>${rfcSucursalAddenda}</gln>
       <nameAndAddress>
           <name>${aliasSucursalAddenda}</name>
           <streetAddressOne>${direccionSucursalAddenda}</streetAddressOne>
           <city>${ciudadSucursalAddenda}</city>
           <postalCode>${cpSucursalAddenda}</postalCode>
           <bodegaEnt>${codigoSucursalAddenda}</bodegaEnt>
       </nameAndAddress>
     </shipTo>
     <currency currencyISOCode="MXN">
       <currencyFunction>BILLING_CURRENCY</currencyFunction>
       <rateOfChange>1.000000</rateOfChange>
     </currency>
     <TotalLotes>
       <cantidad>${cantidadCajasAddenda}</cantidad>
     </TotalLotes>
   <INILISTAPROD>
     ${artAddString}
   </INILISTAPROD>
     <totalAmount>
       <Amount>${subTotalAddenda}</Amount>
     </totalAmount>
     <TotalAllowanceCharge allowanceOrChargeType="ALLOWANCE">
       <specialServicesType>TD</specialServicesType>
       <Amount>${descuento1Addenda + descuento2Addenda}</Amount>
     </TotalAllowanceCharge>
     <baseAmount>
       <Amount>${subTotalAddenda - descuento1Addenda - descuento2Addenda}</Amount>
     </baseAmount>
     <tax type="VAT">
       <taxPercentage>16.00</taxPercentage>
       <taxAmount>${ivaAddenda}</taxAmount>
       <taxCategory>TRANSFERIDO</taxCategory>
     </tax>
     <payableAmount>
       <Amount>${totalAddenda}</Amount>
     </payableAmount>
     <cadenaOriginal>
       <Cadena>${cadenaOriginalAddenda}</Cadena>
     </cadenaOriginal>
      </requestForPayment>
      </cfdi:Addenda>`;

   const facturaXMLBase64 = response.data.respuesta.Content;

    const facturaXMLDecoded = atob(facturaXMLBase64);

    const combinedXML = facturaXMLDecoded.replace('</cfdi:Comprobante>', textoAdenda + '</cfdi:Comprobante>');

    const facturaBlob = new Blob([combinedXML], { type: 'application/xml' });

    const dataURL = URL.createObjectURL(facturaBlob);

    const a = document.createElement('a');
    a.href = dataURL;
    a.download = `Addenda-Factura${serieAddenda}-${folioAddenda}.xml`;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } catch (err) {
    console.error(err);
  }
}


  let totalImporteTabla = 0;
  let subTotalTabla = 0;
  let totalIVATabla = 0;

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_admin ? (
        <div className="card col-12">
          <Row>
          <Col md={8}>
            <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/FacturasCreate"
                >
                  Nueva Factura
                </Button>
              <Button
                size="sm"
                href="/MenuFiscal"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado de Facturas</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Facturas</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>Clientes</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedCliente}
                onChange={(e) => {
                  setSelectedCliente(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                if(a.is_active == "No"){
                  return (
                    <tr style={{ backgroundColor: "#ed8c8c"}}>
                      <td>{a.idFactura}</td>
                      <td>{a.fecha}</td>
                      <td>{a.clientes}</td>
                      <td>{a.vendedores}</td>
                      <td>{a.serie} {a.folio}</td>
                      <td></td>
                      <td>CANCELADA</td>
                      <td>
                      <>
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFOC(
                                  a.idFacturama,
                                  a.serie,
                                  a.folio
                                )
                              }
                            >
                              <i class="far fa-file-pdf"></i>
                            </Button>
                      <Button
                              size="sm"
                              className="btn"
                              color="info"
                              onClick={(e) =>
                                PDFOCXMLCANCELADA(
                                  a._id,
                                  a.serie,
                                  a.folio
                                )
                              }
                            >
                            <i class="fas fa-file-alt"></i>
                            </Button>
                      </>
                      </td>
                    </tr>
                  );
                }else{
                  // totalImporteTabla = totalImporteTabla + a.total_general;
                  // subTotalTabla = subTotalTabla + a.subTotal;
                  // totalIVATabla = totalIVATabla + a.iva;
                  return (
                    <tr>
                       <td>{a.idFactura}</td>
                      <td>{a.fecha}</td>
                      <td>{a.clientes}</td>
                      <td>{a.vendedores}</td>
                      <td>{a.serie} {a.folio}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total)}</td>
                      <td>{a.timbre}</td>
                      <td>
                        {a.timbre == "Si" ? (
                          
                          <>
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFOC(
                                  a.idFacturama,
                                  a.serie,
                                  a.folio
                                )
                              }
                            >
                              <i class="far fa-file-pdf"></i>
                            </Button>

                            <Button
                              size="sm"
                              className="btn"
                              color="info"
                              onClick={(e) =>
                                PDFOCXML(
                                  a.idFacturama,
                                  a.serie,
                                  a.folio
                                )
                              }
                            >
                              <i class="fas fa-file-alt"></i>
                            </Button>

                            <Button
                              size="sm"
                              className="btn"
                              color="success"
                              onClick={(e) =>{
                                jalaAddenda(a._id, a.idClientes)
                                setIdFacturamaAddenda(a.idFacturama)
                                  setSerieAddenda(a.serie)
                                  setFolioAddenda(a.folio)
                                  setFechaAddenda(a.fecha)
                                  setSubTotalAddenda(a.subTotal)
                                  setIvaAddenda(a.iva)
                                  setTotalAddenda(a.total)
                                  setDescuento1Addenda(a.descuentoNumero1)
                                  setDescuento2Addenda(a.descuentoNumero2)
                                  setCadenaOriginalAddenda(a.cadenaSAT)
                                }
                              }
                            >
                              <i class="fas fa-file-alt"></i>
                            </Button>

                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) => cancelarFactura(a._id, a.idFacturama)}
                            >
                              <i class="fas fa-ban"></i>
                            </Button>
                          </>
                        ): undefined}
                      </td>
                    </tr>
                  );
                }

              })}
              {/* <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="center">
                  TOTAL
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(subTotalTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalIVATabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalImporteTabla)}
                </td>
                <td></td>
              </tr> */}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>

          <Modal size="xl" isOpen={modalAddenda} toggle={toggleAddenda}>
            <ModalHeader toggle={toggleAddenda}>
              <h4>Addenda</h4>
            </ModalHeader>
            <ModalBody>
              <Row>
            <Col md={2}>
                <Label>Tipo de Addenda</Label>
                    <Input
                      type="select"
                      value={addendaTipo}
                      required
                      onChange={(event) => {
                        setAddendaTipo(event.target.value);
                      }}
                    >
                      <option value="">Selecciona</option>
                      <option value="Coppel">Coppel</option>
                      <option value="Soriana">Soriana</option>
                      <option value="Control">Control</option>
                      <option value="Emsa">Emsa</option>
                    </Input>
                  </Col>
                  </Row>
                  <br />
      {addendaTipo == "Coppel" ? (
        <>
        <Row>
        <Col md={2}>
          <Label>
            Pedido
          </Label>
          <Input
            type="text"
            placeholder="Pedido"
            value={pedidoAddenda}
            required
            onChange={(e) => {
              setPedidoAddenda(e.target.value);
            }}
          />
        </Col>
        <Col md={2}>
          <Label>
            Fecha Pedido
          </Label>
          <Input
            type="date"
            value={fechaPedidoAddenda}
            required
            onChange={(e) => {
              setFechaPedidoAddenda(e.target.value);
            }}
          />
        </Col>
        <Col md={2}>
          <Label>
            Cajas
          </Label>
          <Input
            type="number"
            placeholder="Cajas"
            value={cantidadCajasAddenda}
            required
            onChange={(e) => {
              setCantidadCajasAddenda(e.target.value);
            }}
          />
        </Col>
      </Row>
      <Row>
      <Col md={2}>
                <Label>
                  Sucursal
                </Label>
                <Input
                  type="select"
                  placeholder="Sucursal"
                  value={selectedSucursal}
                  required
                  onChange={(e) => {
                    jalaSucursal(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  {sucursales.map((a) => {
                    return(
                    <option value={a._id}>{a.alias}</option>
                    )})}
                  </Input>
              </Col>
              <Col md={3}>
          <Label>
            Direccion
          </Label>
          <Input
            type="text"
            placeholder="Direccion"
            value={direccionSucursalAddenda}
            required
            disabled
          />
        </Col>
        <Col md={2}>
          <Label>
            Ciudad
          </Label>
          <Input
            type="text"
            placeholder="Ciudad"
            value={ciudadSucursalAddenda}
            required
            disabled
          />
        </Col>
        <Col md={2}>
          <Label>
            CP
          </Label>
          <Input
            type="text"
            placeholder="CP"
            value={cpSucursalAddenda}
            required
            disabled
          />
        </Col>
        <Col md={2}>
          <Label>
            Codigo
          </Label>
          <Input
            type="text"
            placeholder="Codigo"
            value={codigoSucursalAddenda}
            required
            disabled
          />
        </Col>
      </Row>

      <br />
      <Row>
        <Col md={2}>
          <Label>
            Sub Total
          </Label>
          <Input
            type="text"
            placeholder="Sub Total"
            value={subTotalAddenda}
            required
            disabled
          />
        </Col>
        <Col md={2}>
          <Label>
            Descuento 1
          </Label>
          <Input
            type="text"
            placeholder="Descuento 1"
            value={descuento1Addenda}
            required
            disabled
          />
        </Col>
        <Col md={2}>
          <Label>
            Descuento 2
          </Label>
          <Input
            type="text"
            placeholder="Descuento 2"
            value={descuento2Addenda}
            required
            disabled
          />
        </Col>
        <Col md={2}>
          <Label>
            IVA
          </Label>
          <Input
            type="text"
            value={ivaAddenda}
            required
            disabled
          />
        </Col>
        <Col md={2}>
          <Label>
            Total
          </Label>
          <Input
            type="text"
            value={totalAddenda}
            required
            disabled
          />
        </Col>

      </Row>
      <ModalFooter>
          <Button color="success" onClick={generarAddenda}>
            Generar
          </Button>
        </ModalFooter>
      </>
      ):undefined}
            </ModalBody>
          </Modal>


        </div>
      ) : undefined}
      <br />
      {loader}
    </>
  );
}

export default ListadoFacturas;
